<template>
    <v-content>
      <v-container fluid>
        <Header :title="title" />
        <v-row no-gutters>
          <v-col cols="12">

            <v-tabs
            v-model="tabs"
          >
              <v-tabs-slider></v-tabs-slider>
              <v-tab v-if="canAddAdditionalPages" href="/additional-pages"> {{ 'Additional Pages' | translate}} </v-tab>
              <v-tab v-if="canAdd" href="#resources" active> {{ 'Resources' | translate}} </v-tab>
          </v-tabs>


            <DataTable
              @deleting="deleting"
              :title="''"
              :headers="headers"
              :items="resources"
              :search="search"
            />
          </v-col>
          <Dialogbox
            @closing="closing"
            @deleteuser="deleteQuiz"
            :title="dialogboxtitle"
            :dialog="dialogstatus"
            :buttonTitle="dialogButtontitle"
            :deleteuser="true"
            v-if="dialogstatus"
          />
        </v-row>
      </v-container>
      <v-btn dark fab fixed bottom right large color="pink" class="mx-2" v-if="canAdd" @click="add">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-content>
  </template>
  
  <script>
  import { mapGetters } from "vuex"
  import store from "@/store"
  import {
    FETCH_PAGE_RESOURCES,
    DELETE_PAGE_RESOURCE,
    RESET_STATE
  } from "@/store/actions.type";
  import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
  export default {
    name: "resources",
    beforeRouteEnter(to, from, next) {
      store.dispatch(RESET_STATE)
      store.dispatch(FETCH_PAGE_RESOURCES, "").then(resp => {
        if (resp.success) {
          store.commit(SET_LOADING, false)
          store.commit(SET_ROUTER_ENTER, false)
        }
      });
      return next();
    },
    beforeRouteLeave(to, from, next) {
      store.dispatch(RESET_STATE)
      next();
    },
    data: function() {
      return {
        title: "Additional Pages - Resources",
        search: "",
        dialogstatus: false,
        dialogButtontitle: null,
        dialogboxtitle: null,
        id: null,
        singleSelect: "",
        dialog: false,
        tabs:'resources',
      };
    },
    components: {
      DataTable: () => import("@/components/datatable/datatable"),
      Dialogbox: () => import("@/components/dialog/dialog"),
      Header: () => import("@/components/header/Header")
    },
    computed: {
      ...mapGetters(["resources",'currentUser']),
      headers () {
        return [
          { text: this.$t("Resource Id"), value: "resource_id" },  
          { text: this.$t("Name"), value: "name" },        
          { text: this.$t("Resource Type"), value: "resource_type" },        
          { text: this.$t("File"), value: "file" },        
          { text: this.$t("Actions"), value: "action", sortable: false }
        ]
      },
      canAdd(){
        if(typeof this.currentUser !== 'undefined') {
          if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-additional-pages-resource')){
            return true;
          }
        }
        return false;
      },
      canAddAdditionalPages(){
        if(typeof this.currentUser !== 'undefined') {
          if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-additional-pages')){
            return true;
          }
        }
        return false;
      }
    },
    methods: {
      add() {
        this.$router.push("/resources/add");
      },
      deleting(id) {
        this.dialogstatus = true
        this.dialogboxtitle = "Are you sure want to remove?"
        this.dialogButtontitle = "Remove"
        this.id = id
      },
      async deleteQuiz() {
        await this.$store
          .dispatch(DELETE_PAGE_RESOURCE, this.id)
          .then(async resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              this.id = null;
              await store.dispatch(FETCH_PAGE_RESOURCES, "").then(resp => {
                if (resp.success) {
                  store.commit(SET_LOADING, false);
                  this.dialogstatus = false;
                }
              });
            }
            else{
              store.commit(SET_LOADING, false);
            }
          });
      },
      closing() {
        this.dialogstatus = false
      },
    }
  };
  </script>